import React from 'react';
import './App.css';
import { PrivateRoute } from './common/PrivateRoutes'
import { PublicRoute } from './common/PublicRoutes';
import AppLogout from './common/isLogout';
import Login from './Pages/Login';
import PgmList from './Pages/PgmList/index';
import Sidebar from './Pages/Sidebar';
import Header from './Pages/Header'
import PgmDetails from './Pages/PgmDetails';
import Rewards from './Pages/Rewards';
import Attendee from "./Pages/Attendee/index"
import Faq from './Pages/Faq';
import CreateFaq from './Pages/CreateFaq';
import EditFaq from './Pages/EditFaq';
import Query from './Pages/Query';
import ViewQuery from './Pages/ViewQuery';
import CreateTrainee from "./Pages/Createtrainee/index"
import CreateTraineeView from "./Pages/CreateTraineeView/index"
import EditTraineeView from "./Pages/EditTraineeView/index"
import TrainingDetailView from './Pages/ViewTraningDetail';
import CreateRewards from './Pages/CreateReward';
import SendInvites from "./Pages/SendInvites/index"
import Faqs from './Pages/Faq_Announcment';
import CreateFaqs from './Pages/CreateFAQ_Ann';
import EditFaqsAnnouncment from './Pages/EditFaqAnnouncement';
import NotFoundPage from './Pages/NotFound/index';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Provider } from 'react-redux';
import ViewTrainer from './Pages/ViewTrainer';
import TrainerList from './Pages/TrainerList';
import CreateTrainer from './Pages/CreateTrainer';
import TrainerNotification from './Pages/TrainersNotification';
import NotificationListening from './Pages/NotificationListening';
import EditNotification from './Pages/EditNotify/index';
import Privacypolicy from './component/privacyComponent/Privacypolicy';
import TermsCondition from './component/TermsCondition';
import DeleteAccount from './component/deleteAccountComponent/DeleteAccount';
import AddRewardRedeem from './Pages/AddRewardRedeem';
import EditRewardRedeem from './Pages/EditRewardRedeem';
import RewardRedeem from './Pages/RewardRedeem';
import RedemptionLimit from './Pages/RedemptionLimit/RedemptionLimit';
import { HelmetProvider } from 'react-helmet-async';
import Cookies from 'js-cookie';
import store from './store'
import ForgetPasswordForm from './component/forgetpassword/forgetpassword';
import ResetPasswordForm from './component/resetpassword/resetpassword';
import ReturnSignIn from './component/returnsignin/returnsignin';
import Setting from './Pages/settings';
import EditBanners from './Pages/EditBanners';
import CreateBanners from './Pages/CreateBanners';
import Banners from './Pages/Banners';
import TruChamp from './Pages/TruChamp';
import ReportGeneration from './Pages/ReportGeneration';
import CreateRole from './Pages/CreateRole';
import EditRole from './Pages/EditRoles';
import User from './Pages/User';
import RoleManagement from './Pages/RoleManagement';
import CreateUser from './Pages/CreateUser';
import EditUser from './Pages/EditUser';
import Nopermission from "./component/loaderComponent/NoPermissions/Nopermission";
import { decode } from "base-64";
import ThankYouPage from './component/Thanku/thankupage';
import CreateMsr from './Pages/CreateMsr';
import EditMsr from './Pages/EditMsr/index';
import Msr from './Pages/Msr/index';
import CreateNotificationExcel from './Pages/CreateNotificationExcel';
import GenerateUniqueId from './Pages/GenerateUniqueId';
import RetailerDetails from './Pages/RetailerDetails';
import RetailerList from './Pages/RetailerList';
import TrainingRoutes from './routes/3w/TrainingRoutes';
import TrainingRoutes2w from './routes/2w/TrainingRoutes';
import SupportRoutes from './routes/3w/SupportRoutes';
import PgmRoutes from './routes/3w/PgmRoutes';
import ReferralRoutes from './routes/3w/ReferralRoute';
import ScanLimit from './Pages/ScanLimit/ScanLimit';
import Refferal2w from './Pages/Refferal2w/Refferal2w';
import TruChampDeepLink from './Pages/TruChampDeepLink';
import DashboardLayout from './Layouts/DashboardLayouts';
import UniqueIdGenerationList from './Pages/UniqueIdGenerationList';
import TruChampDeepLinkNew from './Pages/TruChampDeepLinkNew';
import Dsr from './Pages/Dsr';
import EditDsr from './Pages/EditDsr';
import CreateDsr from './Pages/CreateDsr';
import BeatMapManagement from './Pages/BeatMapManagement';
// import IncentiveConfiguration from './Pages/IncentiveMapping';
import DbtRuleManagment from './Pages/DbtRuleMangement';
import CreateDBTRule from './Pages/CreateDBTRule';
import PincodeMasterList from './Pages/PincodeMasterList';
import TargetVsAchievement from './Pages/TargetVsAchievement';
import CustomerDetailPage from './Pages/TargetVsAchievement/CustomerDetailPage';
import SingleCustomerDetail from './Pages/TargetVsAchievement/SingleCustomerDetail';
import DbtConfiguration from './Pages/settings/DbtConfiguration';

var rolepermission
var Role = ""

function App() {
  var localData = Cookies.get("ispermission") ? JSON.parse(Cookies.get("ispermission")) : "";
  var RoleData = Cookies.get('role') ? Cookies.get('role') : "";
  var vehicleType = Cookies.get('vehicletype') ? Cookies.get('vehicletype') : "";
  if (localData) {
    rolepermission = localData?.permissions
  }
  if (RoleData) {
    Role = decode(RoleData)
  }
  if (vehicleType) {
    vehicleType = decode(vehicleType)
  }
  const is3w = () => {
    return vehicleType == "3W"
  };

  return (
    <div className="App">
      <Provider store={store}>
        <HelmetProvider>
          <Router>
            <Routes>
              {
                Role.toLowerCase() === 'super_admin' ? (
                  <>
                    <Route element={<AppLogout><PrivateRoute><DashboardLayout /></PrivateRoute></AppLogout>}>
                      <Route exact path="/query" element={<AppLogout><PrivateRoute><Query /></PrivateRoute></AppLogout>} />
                      <Route exact path="/viewquery/:id" element={<AppLogout><PrivateRoute><ViewQuery /></PrivateRoute></AppLogout>} />
                      <Route exact path="/createbanners" element={<AppLogout><PrivateRoute><CreateBanners /></PrivateRoute></AppLogout>} />
                      <Route exact path="/editbanners/:id" element={<AppLogout><PrivateRoute><EditBanners /></PrivateRoute></AppLogout>} />
                      <Route exact path="/banners" element={<AppLogout><PrivateRoute><Banners /></PrivateRoute></AppLogout>} />
                      <Route exact path="/createuser" element={<AppLogout><PrivateRoute><CreateUser /></PrivateRoute></AppLogout>} />
                      <Route exact path="/edituser/:id" element={<AppLogout><PrivateRoute><EditUser /></PrivateRoute></AppLogout>} />
                      <Route exact path="/createrole" element={<AppLogout><PrivateRoute><CreateRole /></PrivateRoute></AppLogout>} />
                      <Route exact path="/editrole/:id" element={<AppLogout><PrivateRoute><EditRole /></PrivateRoute></AppLogout>} />
                      <Route exact path="/user" element={<AppLogout><PrivateRoute><User /></PrivateRoute></AppLogout>} />
                      <Route exact path="/rolemanagement" element={<AppLogout><PrivateRoute><RoleManagement /></PrivateRoute></AppLogout>} />
                      <Route exact path="/editmsr/:id" element={<AppLogout><PrivateRoute><EditMsr /></PrivateRoute></AppLogout>} />
                      <Route exact path="/createmsr" element={<AppLogout><PrivateRoute><CreateMsr /></PrivateRoute></AppLogout>} />
                      <Route exact path="/msr" element={<AppLogout><PrivateRoute><Msr /></PrivateRoute></AppLogout>} />
                      <Route exact path="/editdsr/:id" element={<AppLogout><PrivateRoute><EditDsr /></PrivateRoute></AppLogout>} />
                      <Route exact path="/createdsr" element={<AppLogout><PrivateRoute><CreateDsr /></PrivateRoute></AppLogout>} />
                      <Route exact path="/dsr" element={<AppLogout><PrivateRoute><Dsr /></PrivateRoute></AppLogout>} />
                      <Route exact path="/beatmanagement" element={<AppLogout><PrivateRoute><BeatMapManagement /></PrivateRoute></AppLogout>} />
                      <Route exact path="/dbtrulemanagement" element={<AppLogout><PrivateRoute><DbtRuleManagment /></PrivateRoute></AppLogout>} />
                      <Route exact path="/pincodemasterlist" element={<AppLogout><PrivateRoute><PincodeMasterList /></PrivateRoute></AppLogout>} />
                      <Route exact path="/createdbt" element={<AppLogout><PrivateRoute><CreateDBTRule /></PrivateRoute></AppLogout>} />
                      <Route exact path="/edit/:editId" element={<AppLogout><PrivateRoute><CreateDBTRule /></PrivateRoute></AppLogout>} />
                      <Route exact path="/view/:viewId" element={<AppLogout><PrivateRoute><CreateDBTRule /></PrivateRoute></AppLogout>} />
                      <Route exact path="/planvsactual" element={<AppLogout><PrivateRoute><TargetVsAchievement /></PrivateRoute></AppLogout>} />
                      <Route exact path="/planvsactual/customer/:apsCode/:month" element={<AppLogout><PrivateRoute><CustomerDetailPage /></PrivateRoute></AppLogout>} />
                      <Route exact path="/planvsactual/customer-detail/:customerCode/:customerName/:apsCode/:month" element={<AppLogout><PrivateRoute><SingleCustomerDetail /></PrivateRoute></AppLogout>} />
                      <Route exact path="/setting/dbtconfiguration" element={<AppLogout><PrivateRoute><DbtConfiguration /></PrivateRoute></AppLogout>} />
                    </Route>
                  </>
                ) : ""
              }
              {localData !== "" ?
                <>
                  <Route exact path="/" element={<PublicRoute><Login /></PublicRoute>} />
                  <Route exact path="/tru_champ" element={<PublicRoute><TruChamp /></PublicRoute>} />
                  <Route exact path="/tru_champ_deeplink" element={<PublicRoute><TruChampDeepLink /></PublicRoute>} />
                  <Route exact path="/sidebar" element={<AppLogout><PrivateRoute><Sidebar /></PrivateRoute></AppLogout>} />
                  <Route exact path="/header" element={<AppLogout><PrivateRoute><Header /></PrivateRoute></AppLogout>} />
                  <Route exact path="/verify_email" element={<AppLogout><PublicRoute><ThankYouPage /></PublicRoute></AppLogout>} />

                  {(Role.toLowerCase() === 'super_admin' || Role.toLowerCase() === '3w_super_admin') && (
                    <>
                      <Route element={<AppLogout><PrivateRoute><DashboardLayout /></PrivateRoute></AppLogout>}>
                        <Route exact path="/banners" element={<AppLogout><PrivateRoute><Banners /></PrivateRoute></AppLogout>} />
                        <Route exact path="/createbanners" element={<AppLogout><PrivateRoute><CreateBanners /></PrivateRoute></AppLogout>} />
                        <Route exact path="/editbanners/:id" element={<AppLogout><PrivateRoute><EditBanners /></PrivateRoute></AppLogout>} />
                        <Route exact path="/rolemanagement" element={<AppLogout><PrivateRoute><RoleManagement /></PrivateRoute></AppLogout>} />
                        <Route exact path="/banners" element={<AppLogout><PrivateRoute><Banners /></PrivateRoute></AppLogout>} />
                        <Route exact path="/createuser" element={<AppLogout><PrivateRoute><CreateUser /></PrivateRoute></AppLogout>} />
                        <Route exact path="/edituser/:id" element={<AppLogout><PrivateRoute><EditUser /></PrivateRoute></AppLogout>} />
                        <Route exact path="/createrole" element={<AppLogout><PrivateRoute><CreateRole /></PrivateRoute></AppLogout>} />
                        <Route exact path="/editrole/:id" element={<AppLogout><PrivateRoute><EditRole /></PrivateRoute></AppLogout>} />
                        <Route exact path="/user" element={<AppLogout><PrivateRoute><User /></PrivateRoute></AppLogout>} />
                      </Route>
                    </>
                  )}

                  {rolepermission?.includes('support_access') ? (
                    <>
                      <Route element={<AppLogout><PrivateRoute><DashboardLayout /></PrivateRoute></AppLogout>}>
                        <Route exact path="/query" element={<AppLogout><PrivateRoute><Query /></PrivateRoute></AppLogout>} />
                        <Route exact path="/viewquery/:id" element={<AppLogout><PrivateRoute><ViewQuery /></PrivateRoute></AppLogout>} />
                      </Route>
                    </>
                  ) : ""}
                  {rolepermission?.includes('can_access_msr') ? (
                    <>
                      <Route element={<AppLogout><PrivateRoute><DashboardLayout /></PrivateRoute></AppLogout>}>
                        <Route exact path="/editmsr/:id" element={<AppLogout><PrivateRoute><EditMsr /></PrivateRoute></AppLogout>} />
                        <Route exact path="/createmsr" element={<AppLogout><PrivateRoute><CreateMsr /></PrivateRoute></AppLogout>} />
                        <Route exact path="/msr" element={<AppLogout><PrivateRoute><Msr /></PrivateRoute></AppLogout>} />
                      </Route>
                    </>
                  ) : ""}
                  {rolepermission?.includes('pgm_registration_approval') ? (
                    <>
                      <Route element={<AppLogout><PrivateRoute><DashboardLayout /></PrivateRoute></AppLogout>}>
                        <Route exact path="/pgmlist" element={<AppLogout><PrivateRoute><PgmList /></PrivateRoute></AppLogout>} />
                        <Route exact path="/pgmdetails/:id" element={<AppLogout><PrivateRoute><PgmDetails /></PrivateRoute></AppLogout>} />
                        <Route exact path="/retailerList" element={<AppLogout><PrivateRoute><RetailerList /></PrivateRoute></AppLogout>} />
                        <Route exact path="/retailerDetails/:id" element={<AppLogout><PrivateRoute><RetailerDetails /></PrivateRoute></AppLogout>} />
                      </Route>
                    </>
                  ) : ""}
                  {rolepermission?.includes('schedule_notifications') ? (
                    <>
                      <Route element={<AppLogout><PrivateRoute><DashboardLayout /></PrivateRoute></AppLogout>}>
                        <Route exact path="/createnotification" element={<AppLogout><PrivateRoute><TrainerNotification /></PrivateRoute></AppLogout>} />
                        <Route exact path="/createnotificationexcel" element={<AppLogout><PrivateRoute><CreateNotificationExcel /></PrivateRoute></AppLogout>} />
                        <Route exact path="/notification" element={<AppLogout><PrivateRoute><NotificationListening /></PrivateRoute></AppLogout>} />
                        <Route exact path="/editnotification/:id" element={<AppLogout><PrivateRoute><EditNotification /></PrivateRoute></AppLogout>} />
                      </Route>
                    </>
                  ) : ""}{rolepermission?.includes('redemption_limit') ? (
                    <>
                      <Route element={<AppLogout><PrivateRoute><DashboardLayout /></PrivateRoute></AppLogout>}>
                        <Route exact path="/redemptionlimit" element={<AppLogout><PrivateRoute><RedemptionLimit /></PrivateRoute></AppLogout>} />
                        <Route exact path="/scanlimit" element={<AppLogout><PrivateRoute><ScanLimit /></PrivateRoute></AppLogout>} />
                        <Route exact path="/refferal2w" element={<AppLogout><PrivateRoute><Refferal2w /></PrivateRoute></AppLogout>} />
                      </Route>
                    </>
                  ) : ""}
                  {rolepermission?.includes('incentive_mapping') ? (
                    <>
                      <Route element={<AppLogout><PrivateRoute><DashboardLayout /></PrivateRoute></AppLogout>}>
                        <Route exact path="/rewardredeem" element={<AppLogout><PrivateRoute><RewardRedeem /></PrivateRoute></AppLogout>} />
                        <Route exact path="/add_rewardredeem" element={<AppLogout><PrivateRoute><AddRewardRedeem /></PrivateRoute></AppLogout>} />
                        <Route exact path="/edit_rewardredeem/:id" element={<AppLogout><PrivateRoute><EditRewardRedeem /></PrivateRoute></AppLogout>} />
                      </Route>
                    </>
                  ) : ""}

                  {rolepermission?.includes('view_reports') ? (
                    <>
                      <Route element={<AppLogout><PrivateRoute><DashboardLayout /></PrivateRoute></AppLogout>}>
                        <Route exact path="/reportgeneration" element={<AppLogout><PrivateRoute><ReportGeneration /></PrivateRoute></AppLogout>} />
                      </Route>
                    </>
                  ) : ""}
                  {rolepermission?.includes('generate_unique_id') ? (
                    <>
                      <Route element={<AppLogout><PrivateRoute><DashboardLayout /></PrivateRoute></AppLogout>}>
                        <Route exact path="/uniqueidgenerationlist" element={<AppLogout><PrivateRoute><UniqueIdGenerationList /></PrivateRoute></AppLogout>} />
                        <Route exact path="/generateuniqueid" element={<AppLogout><PrivateRoute><GenerateUniqueId /></PrivateRoute></AppLogout>} />
                      </Route>
                    </>
                  ) : ""}
                  {rolepermission?.includes('can_access_dsr') ? (
                    <>
                      <Route element={<AppLogout><PrivateRoute><DashboardLayout /></PrivateRoute></AppLogout>}>
                        <Route exact path="/dsr" element={<AppLogout><PrivateRoute><Dsr /></PrivateRoute></AppLogout>} />
                        <Route exact path="/editdsr/:id" element={<AppLogout><PrivateRoute><EditDsr /></PrivateRoute></AppLogout>} />
                        <Route exact path="/createdsr" element={<AppLogout><PrivateRoute><CreateDsr /></PrivateRoute></AppLogout>} />
                      </Route>
                    </>
                  ) : ""}
                   {rolepermission?.includes('can_access_dbt_mapping') ? (
                    <>
                      <Route element={<AppLogout><PrivateRoute><DashboardLayout /></PrivateRoute></AppLogout>}>
                      <Route exact path="/dbtrulemanagement" element={<AppLogout><PrivateRoute><DbtRuleManagment /></PrivateRoute></AppLogout>} />
                      <Route exact path="/createdbt" element={<AppLogout><PrivateRoute><CreateDBTRule /></PrivateRoute></AppLogout>} />
                      <Route exact path="/edit/:editId" element={<AppLogout><PrivateRoute><CreateDBTRule /></PrivateRoute></AppLogout>} />
                      <Route exact path="/view/:viewId" element={<AppLogout><PrivateRoute><CreateDBTRule /></PrivateRoute></AppLogout>} />
                      </Route>
                    </>
                  ) : ""}
                  {rolepermission?.includes('upload_beat_plan') ? (
                    <>
                      <Route element={<AppLogout><PrivateRoute><DashboardLayout /></PrivateRoute></AppLogout>}>
                        <Route exact path="/beatmanagement" element={<AppLogout><PrivateRoute><BeatMapManagement /></PrivateRoute></AppLogout>} />
                      </Route>
                    </>
                  ) : ""}

                  {rolepermission?.includes('upload_pincode_master') ? (
                    <>
                      <Route element={<AppLogout><PrivateRoute><DashboardLayout /></PrivateRoute></AppLogout>}>
                      <Route exact path="/pincodemasterlist" element={<AppLogout><PrivateRoute><PincodeMasterList /></PrivateRoute></AppLogout>} />
                      </Route>
                    </>
                  ) : ""}

                  {rolepermission?.includes('target_vs_achievement') ? (
                    <>
                      <Route element={<AppLogout><PrivateRoute><DashboardLayout /></PrivateRoute></AppLogout>}>
                        <Route exact path="/planvsactual" element={<AppLogout><PrivateRoute><TargetVsAchievement /></PrivateRoute></AppLogout>} />
                        <Route exact path="/planvsactual/customer/:apsCode/:month" element={<AppLogout><PrivateRoute><CustomerDetailPage /></PrivateRoute></AppLogout>} />
                        <Route exact path="/planvsactual/customer-detail/:customerCode/:customerName/:apsCode/:month" element={<AppLogout><PrivateRoute><SingleCustomerDetail /></PrivateRoute></AppLogout>} />
                      </Route>
                    </>
                  ) : ""}

                  
                  {is3w() && <>{TrainingRoutes()}</>}
                  {rolepermission?.includes('can_access_msr') && !is3w() && <>{TrainingRoutes2w()}</>}
                  {rolepermission?.includes('pgm_registration_approval') ? (
                    <>
                      {is3w() && <>{PgmRoutes()}</>}
                    </>
                  ) : null}
                  {rolepermission?.includes('support_access') ? (
                    <>
                      {is3w() && <>{SupportRoutes()}</>}
                    </>
                  ) : null}
                  {is3w() && <>{ReferralRoutes()}</>}
                  <Route element={<AppLogout><PrivateRoute><DashboardLayout /></PrivateRoute></AppLogout>}>
                    <Route exact path="/setting/changepassword" element={<AppLogout><PrivateRoute><Setting /></PrivateRoute></AppLogout>} />
                    <Route exact path="/setting/dbtconfiguration" element={<AppLogout><PrivateRoute><DbtConfiguration /></PrivateRoute></AppLogout>} />
                  </Route>
                </>
                : <>
                  <Route exact path="/" element={<PublicRoute><Login /></PublicRoute>} />
                  <Route exact path="/tru_champ" element={<PublicRoute><TruChamp /></PublicRoute>} />
                  <Route exact path="/tru_champ_deeplink" element={<PublicRoute><TruChampDeepLink /></PublicRoute>} />
                  <Route exact path="/t/:id?" element={<PublicRoute><TruChampDeepLinkNew /></PublicRoute>} />
                  <Route exact path="/sidebar" element={<AppLogout><PrivateRoute><Sidebar /></PrivateRoute></AppLogout>} />
                  <Route exact path="/header" element={<AppLogout><PrivateRoute><Header /></PrivateRoute></AppLogout>} />
                  <Route exact path="/privacy_policy" element={<AppLogout><PublicRoute><Privacypolicy /></PublicRoute></AppLogout>} />
                  <Route exact path="/terms_use" element={<AppLogout><PublicRoute><TermsCondition /></PublicRoute></AppLogout>} />
                  <Route exact path="/delete_account" element={<AppLogout><PublicRoute><DeleteAccount /></PublicRoute></AppLogout>} />
                  <Route exact path="/forgotpassword" element={<AppLogout><PublicRoute><ForgetPasswordForm /></PublicRoute></AppLogout>} />
                  <Route exact path="/resetpassword" element={<AppLogout><PublicRoute><ResetPasswordForm /></PublicRoute></AppLogout>} />
                  <Route exact path="/setting/changepassword" element={<AppLogout><PrivateRoute><Setting /></PrivateRoute></AppLogout>} />
                  <Route exact path="/setting/dbtconfiguration" element={<AppLogout><PrivateRoute><DbtConfiguration /></PrivateRoute></AppLogout>} />
                  <Route exact path="/passwordconfirmation" element={<AppLogout><PublicRoute><ReturnSignIn /></PublicRoute></AppLogout>} />
                  <Route exact path="/verify_email" element={<AppLogout><PublicRoute><ThankYouPage /></PublicRoute></AppLogout>} />
                  <Route exact path="*" element={<AppLogout><PrivateRoute><NotFoundPage /></PrivateRoute></AppLogout>} />
                </>}
              <Route exact path="*" element={<AppLogout><PrivateRoute><Nopermission /></PrivateRoute></AppLogout>} />
            </Routes>
          </Router>
        </HelmetProvider>
      </Provider>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default App;
